"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.SelectPickupPointDialog = void 0;
var _mui = require("@ori-ui/mui");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _react = require("react");
var _contexts = require("../../contexts");
var _models = require("../../models");
var _components = require("./components");
var _hooks = require("./hooks");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
const transitionProps = {
  timeout: 0
};
const SelectPickupPointDialog = ({
  open
}) => {
  const {
    getTestId
  } = (0, _testidGenerator.default)();
  const [initialOpenDone, setInitialOpenDone] = (0, _react.useState)(false);
  const isMobile = (0, _mui.useMediaQuery)(theme => theme.breakpoints.down('md'));
  const {
    togglePickupPointsDialog
  } = (0, _contexts.useMap)();
  (0, _hooks.useSelectInitialPickupPoint)();
  (0, _hooks.useLocateSelectedPickupPointOnReopen)(open);
  (0, _hooks.useFallbackAddressIfNoAddressSet)(open);
  const drawerRef = (0, _react.useRef)(null);
  const {
    height,
    focusOnList,
    focusOnMap,
    onTouchStart
  } = (0, _hooks.useDrawerHeight)(drawerRef);
  const drawerVisible = open && initialOpenDone;
  (0, _react.useEffect)(() => {
    if (open && !initialOpenDone) {
      setInitialOpenDone(true);
    }
  }, [open, initialOpenDone]);
  if (isMobile) {
    return initialOpenDone ? /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.DrawerWrapper, {
      visible: drawerVisible,
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_components.Map, {
        onMapClick: focusOnMap
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.Drawer, {
        ref: drawerRef,
        style: {
          height
        },
        children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.Root, {
          ref: drawerRef,
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.DragHandle, {
            onClick: focusOnList,
            onTouchStart: onTouchStart
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_components.LeftPanel, {
            onPickupPointsListClick: focusOnList
          })]
        })
      })]
    }) : null;
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.Dialog, {
    hideCloseButton: true,
    open: open,
    size: "small",
    transitionProps: transitionProps,
    "data-testid": getTestId(_models.TestId.SelectPickupPointDialog),
    onClose: togglePickupPointsDialog,
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.Root, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_components.LeftPanel, {}), /*#__PURE__*/(0, _jsxRuntime.jsx)(_components.Map, {})]
    })
  });
};
exports.SelectPickupPointDialog = SelectPickupPointDialog;
var _default = exports.default = SelectPickupPointDialog;